import {Component, OnDestroy, OnInit} from '@angular/core';
import { SwaService } from '../../../../service/services/misc/swa/swa.service';
import {EventService} from "../../../../service/services/misc/event/event.service";
import {Subscription} from "rxjs";
import {FullscreenService} from "../fullscreen/fullscreen.service";
import {AiAssistantService} from "../../../../service/services/misc/ai-assistant/ai-assistant.service";
import {Utils} from "../../../helpers/Utils";

@Component({
    selector: 'app-organizations',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
    condensed = true;
    showBreadcrumbs = true;
    eventServiceSubscription: Subscription;
    Utils = Utils;

    constructor(private swaService: SwaService, private eventService: EventService, private fullscreenService: FullscreenService, protected aiAssistantService: AiAssistantService) {}
    ngOnInit(): void {
        this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.PAGE_LOADED, [], []);
        this.eventServiceSubscription = this.eventService.pageLoadEventListener().subscribe(msg =>{
            this.showBreadcrumbs = msg !== 'error';
        });
    }

    isInFullscreen(): boolean {
        return this.fullscreenService.isActive();
    }

    onToggleCondensed() {
        this.condensed = !this.condensed;
    }

    ngOnDestroy() {
        if (this.eventServiceSubscription) {
            this.eventServiceSubscription.unsubscribe();
        }
    }
}
